export default __webpack_public_path__ + "static/media/story_cover_illustrator.147a63d8.png";